import {connect} from 'react-redux';

import {
  createSelector,
  makeMapDispatchToProps,
  makeMapStateToProps,
} from '../../../../../srcCommon/helpers/reselectHelpers';
import {computeJobProgress} from '../../../../helpers/jobHelpers';
import {CrmSyncModel} from '../../../../models/api/crmSyncModel';
import {SyncJobModel} from '../../../../models/api/jobModel';
import {AppState} from '../../../../store/appState';
import {
  getHasCrmSyncFullPageSalesforce,
  getHasHubspotContactSync,
} from '../../../../store/featureFlags/featureFlagsSelectors';
import {contactsManagerTableForceRefreshAction} from '../../../../store/panels/contacts/contactsManager/table/contactsManagerTableActions';
import {navigateToLinkAction} from '../../../../store/stateless/navigationActions';
import {SyncJobBanner} from './syncJobBanner';

/*
 * Props.
 */

interface SyncJobBannerContainerProps {
  job: SyncJobModel;
  crmSync: CrmSyncModel;
}

/*
 * Selectors.
 */

function getJob(_state: AppState, props: SyncJobBannerContainerProps) {
  return props.job;
}

function makeGetProgress() {
  return createSelector([getJob], (job) => computeJobProgress(job));
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<SyncJobBannerContainerProps>()(() => ({
  progress: makeGetProgress(),
  hasCrmSyncFullPageSalesforce: getHasCrmSyncFullPageSalesforce,
  hasHubspotContactSync: getHasHubspotContactSync,
}));

const mapDispatchToProps = makeMapDispatchToProps<SyncJobBannerContainerProps>()(({crmSync}) => ({
  navigateToLink: navigateToLinkAction,
  tableForceRefresh: contactsManagerTableForceRefreshAction,
}));

export const SyncJobBannerContainer = connect(mapStateToProps, mapDispatchToProps)(SyncJobBanner);
